import {
  FOCUS_OUTLINE_STYLES,
  FOCUS_OUTLINE_STYLES_SECONDARY,
} from "../button/button-styles";
import type { IconButtonStyles } from "./icon-button-types";
import { cn } from "../../utilities/tailwind";

export const ICON_BUTTON_STYLES = {
  base: cn(
    `flex items-center justify-center rounded-full enabled:cursor-pointer data-[size=extraSmall]:focus-visible:-outline-offset-1 ${FOCUS_OUTLINE_STYLES}`,
  ),
  color: {
    minimal: cn(
      "bg-white text-royal-blue enabled:hover:bg-off-white enabled:focus-visible:bg-off-white",
    ),
    primary: cn(
      "bg-royal-blue text-white enabled:hover:bg-core-blue enabled:focus-visible:bg-core-blue",
    ),
    secondary: cn(
      `bg-orange text-white enabled:hover:bg-dark-orange enabled:focus-visible:bg-dark-orange ${FOCUS_OUTLINE_STYLES_SECONDARY}`,
    ),
    standard: cn(
      "border border-dark-gray bg-white text-royal-blue enabled:hover:bg-off-white enabled:focus-visible:bg-off-white",
    ),
  },
  disabled: cn(
    "disabled:pointer-events-none disabled:border disabled:border-medium-gray disabled:bg-off-white disabled:text-medium-gray disabled:focus-visible:bg-off-white data-[size=extraSmall]:disabled:size-8 data-[size=extraSmall]:disabled:focus-visible:outline-offset-[3px]",
  ),
  extraSmallStandard: {
    border: cn("h-8 min-w-8 rounded-full border border-dark-gray"),
    disabled: cn("disabled:border-none disabled:bg-transparent"),
  },
  iconSize: {
    extraSmall: cn("size-2"),
    large: cn("size-4"),
    medium: cn("size-3"),
    small: cn("size-3"),
  },
  size: {
    extraSmall: cn("size-10 border-4 border-transparent bg-clip-padding"),
    large: cn("size-[57px]"),
    medium: cn("size-12"),
    small: cn("size-10"),
  },
} satisfies IconButtonStyles;
